import $ from "jquery";
import CustomTagEditable from "libs/jquery-editable/modules/custom.tag.editable";

class TextAreaEditable extends CustomTagEditable {
    element(settings, original) {
        const textarea = $('<textarea />');
        if (settings.rows) {
            textarea.attr('rows', settings.rows);
        } else if (settings.height !== "none") {
            textarea.height(settings.height);
        }
        if (settings.cols) {
            textarea.attr('cols', settings.cols);
        } else if (settings.width !== "none") {
            textarea.width(settings.width);
        }
        if (settings.preprocess) {
            settings.preprocess(textarea);
        } //ds
        $(this).append(textarea);
        return textarea;
    }

}

export default TextAreaEditable;